exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more-navigation[data-v-79a1c07c] {\n  position: relative;\n}\n.more-navigation--open icon[data-v-79a1c07c] {\n  opacity: 1;\n}\n", ""]);

// exports
